import { render } from "./mute-vv-multiselect.vue?vue&type=template&id=9ed769cc"
import script from "./mute-vv-multiselect.vue?vue&type=script&lang=js"
export * from "./mute-vv-multiselect.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__